// extracted by mini-css-extract-plugin
export var border = "_v-7";
export var brand = "_v-s";
export var button = "_v-k";
export var center = "_v-9";
export var centered = "_v-5";
export var closeButton = "_v-b";
export var disabledWrapper = "_v-l";
export var error = "_v-o";
export var extraLarge = "_v-4";
export var extraSmall = "_v-1";
export var fill = "_v-h";
export var footer = "_v-g";
export var footerAction = "_v-i";
export var footerButtons = "_v-j";
export var header = "_v-6";
export var headerWithClose = "_v-c";
export var icon = "_v-n";
export var info = "_v-r";
export var inline = "_v-8";
export var large = "_v-3";
export var main = "_v-d";
export var modal = "_v-0";
export var neutral = "_v-t";
export var noPadding = "_v-f";
export var none = "_v-u";
export var scrollable = "_v-e";
export var small = "_v-2";
export var success = "_v-q";
export var tight = "_v-m";
export var titleIcon = "_v-a";
export var warn = "_v-p";